import { render, staticRenderFns } from "./ui-theme.vue?vue&type=template&id=3cd5b43b"
import script from "./ui-theme.vue?vue&type=script&lang=js"
export * from "./ui-theme.vue?vue&type=script&lang=js"
import style0 from "./ui-theme.vue?vue&type=style&index=0&id=3cd5b43b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports